import { clearAllCookies } from "./clearAllCookies";
import { LANGUAGE_STORAGE_KEY } from "../../shared/utils/interfaceLanguage";

// Limpieza compartida para todo punto donde se cierra sesión (logout manual,
// logout automático por inactividad, o los distintos checks de token
// vencido/estatus inválido repetidos en varias pantallas). Evita seguir
// copiando "localStorage.clear() + sessionStorage.clear()" sin las cookies.
//
// El idioma de la interfaz NO es dato de sesión: es una preferencia de quien usa
// el navegador y sobrevive al cierre. Antes se iba en el `localStorage.clear()`,
// así que al expirar la sesión la aplicación volvía siempre a inglés —y el aviso
// de "sesión expirada", escrito en español dentro del código, quedaba en un
// idioma distinto al del resto de la pantalla. Conservarlo es lo que permite que
// esa pantalla y su aviso hablen el mismo idioma.
export const clearSessionData = () => {
  const language = localStorage.getItem(LANGUAGE_STORAGE_KEY);
  localStorage.clear();
  sessionStorage.clear();
  if (language !== null) localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  clearAllCookies();
};
